import { lazy } from 'react'
import Login from '@/views/login'

export const LOGIN_PATH = '/login'
export const DOWNLOAD_APP_PATH = '/downloadApp'
export const LARY_REDIRECT = `/login/lark/:id`
export const APP_REDIRECT = `/login/appRedirect`

const routers = [
  {
    path: APP_REDIRECT, // app重定向中间页
    component: lazy(() => import('@/views/appRedirect')),
    exact: true
  },
  {
    path: LARY_REDIRECT, // 飞书重定向中间页
    component: lazy(() => import('@/views/larkRedirect')),
    exact: true
  },
  {
    path: LOGIN_PATH, // 登录
    component: Login
  },
  {
    path: DOWNLOAD_APP_PATH, // 下载app
    component: lazy(() => import('@/views/downloadApp'))
  }
]

export default routers